export const UnauthorizedErrorName = 'UnauthorizedError';
export const ForbiddenErrorName = 'ForbiddenError';
export const ApiErrorName = 'ApiError';
export const EmailForbidden = 'username_cannot_be_an_email_address';
